import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions, ViewStyle} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return CreateResponsiveStyle(
    {
      containerStyle: {
        marginBottom: 30,
        width: width - 32,
      },
      titleContainerStyle: {
        marginBottom: 8,
        fontSize: 14,
        lineHeight: 18,
        color: colors.primaryTextColor,
        ...typography.mulishSemibold,
      },
      daysBarContainerStyle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        containerStyle: {
          flexDirection: 'row',
          alignItems: 'center',
        },
        titleContainerStyle: {
          marginBottom: 0,
          marginRight: 8,
          width: 90,
          fontSize: 18,
          lineHeight: 18,
          color: colors.primaryTextColor,
          ...typography.mulishSemibold,
        },
        daysBarContainerStyle: {
          width: 320,
        },
      },
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {
        titleContainerStyle: {
          width: 130,
        },
        daysBarContainerStyle: {
          width: 504,
        },
      },
    },
  )();
};
